import { ModelApi } from '@/services/api/modelApi'

/**
 * Transaction Fee endpoint extends model api to inherit its methods and custom methods up to its needs
 * @param moduleName
 * @param sectionPath
 */
export class TransactionFeeEndpoints<Type> extends ModelApi<Type> {
  constructor(sectionPath: string, moduleName?: string) {
    super(sectionPath, moduleName)
  }
}
